import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { HttpError } from '../api';
import { Button } from '../design';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
      navigate('/products', { replace: true });
    } catch (e) {
      if (e instanceof HttpError) {
        setError(e.status === 401 ? 'Неверный email или пароль' : `Ошибка: ${e.message}`);
      } else {
        setError((e as Error).message);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--bg)' }}>
      <form onSubmit={onSubmit} className="card" style={{ width: 360, padding: 32 }}>
        <h1 style={{ margin: '0 0 8px', fontSize: 22 }}>Ozon koleso tools</h1>
        <p className="muted" style={{ margin: '0 0 24px' }}>Вход в систему</p>

        <label style={{ display: 'block', marginBottom: 12 }}>
          <div style={{ fontSize: 12, marginBottom: 4, color: 'var(--text-muted)' }}>Email</div>
          <input
            type="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: 10, border: '1px solid var(--border)', borderRadius: 6 }}
          />
        </label>

        <label style={{ display: 'block', marginBottom: 16 }}>
          <div style={{ fontSize: 12, marginBottom: 4, color: 'var(--text-muted)' }}>Пароль</div>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: 10, border: '1px solid var(--border)', borderRadius: 6 }}
          />
        </label>

        {error && <div style={{ color: 'var(--red)', fontSize: 13, marginBottom: 12 }}>{error}</div>}

        <Button type="submit" variant="primary" loading={busy} fullWidth>
          Войти
        </Button>
      </form>
    </div>
  );
}
